import React from "react";
import { Wheel } from "react-custom-roulette";
import {
	WheelContainer,
	OuterBadge,
	SpinButton,
	ButtonWrapper,
	SpinStartWrapper,
} from "../SpinHome.style";
import { t } from "i18next";

const textColors = [
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
];
const backgroundColors = [
	"#00CE00",
	"#007257",
	"#0058CB",
	"#0930AC",
	"#5B00B7",
	"#DC00DE",
	"#CD1000",
	"#FF5400",
	"#FF8E00",
	"#FFBC00",
];

// const textColors = ["#342309"];
// const backgroundColors = ["#fffcf3", "#fd1615"];

const props = {
	textColors,
	backgroundColors,
	fontFamily: "Libre Franklin",
	fontWeight: "bolder",
	fontSize: 19,
	radiusLineWidth: 0,
	outerBorderWidth: 0,
	innerBorderColor: "#FFA500",
	innerBorderWidth: 6,
	innerRadius: 0,
	textDistance: 67,
};

const SpinWheel = ({
	handleSpinClicked,
	started,
	winningIndex,
	spinValues,
	handleStop,
	goToHistory,
	goToRule,
}) => {
	return (
		<div
			style={{
				position: "relative",
			}}
		>
			<WheelContainer>
				<Wheel
					disableInitialAnimation={true}
					mustStartSpinning={started}
					prizeNumber={winningIndex}
					data={spinValues}
					onStopSpinning={handleStop}
					onClick={handleSpinClicked}
					{...props}
				/>
				<OuterBadge />
				<SpinStartWrapper onClick={handleSpinClicked}>
					{t("spin.start")}
				</SpinStartWrapper>
			</WheelContainer>
			<ButtonWrapper>
				<SpinButton isRule={true} onClick={goToRule}>
					{" "}
					{t("spin.rule")}{" "}
				</SpinButton>
				<SpinButton onClick={goToHistory}> {t("spin.history")} </SpinButton>
			</ButtonWrapper>
		</div>
	);
};

export default SpinWheel;
